class Dialog {
	/**
	 * @type {Dialog | null}
	 */
	static instance = null;

	constructor() {
		if (!Dialog.instance) {
			this._init();

			Dialog.instance = this;
		}

		return Dialog.instance;
	}

	_init() {
		document.querySelectorAll(`dialog`).forEach((dialogEl) => {
			// Close on backdrop click
			dialogEl.addEventListener('click', (e) => {
				if (e.target === dialogEl) {
					dialogEl.close();
				}
			});
		});

		// Bind Toggles
		document.querySelectorAll(`.js-tk-dialog-toggle`).forEach((toggle) => {
			toggle.addEventListener('click', (e) => {
				e.preventDefault();

				const selector = toggle.dataset.tkDialogSelector;
				const dialogEl = document.querySelector(selector);

				if (!dialogEl) {
					throw new Error(`Dialog not found: ${selector}`);
				}

				const action = toggle.dataset.tkDialogAction ?? 'open';
				const type = toggle.dataset.tkDialogType ?? 'modal';

				if (action === 'open') {
					if (type === 'modal') {
						dialogEl.showModal();
					} else {
						dialogEl.show();
					}
				} else if (action === 'close') {
					dialogEl.close();
				} else {
					throw new Error(`Invalid action: ${action}`);
				}
			});
		});
	}
}

window.tkDialog = new Dialog();
